import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import './NotInvoicingModal.scss';

class NotInvoicingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: props.reason,
    };

    this.handleNotInvoicing = this.handleNotInvoicing.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleNotInvoicing() {
    const {
      invoiceId, projectId, consultantId, monthYear, csrfToken, notInvoicingUrl, redirectUrl,
    } = this.props;
    const { reason } = this.state;

    postRequest(
      notInvoicingUrl,
      {
        resource_id: invoiceId,
        project_id: projectId,
        consultant_id: consultantId,
        start_date: monthYear,
        reason,
      },
      csrfToken,
    ).then(() => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        window.location.reload();
      }
    });
  }

  handleChange(reason) {
    this.setState({ reason });
  }

  render() {
    const {
      consultantName, monthYear, triggerType, triggerText, isConsultant,
    } = this.props;
    const { reason } = this.state;
    return (
      <ModalTrigger
        triggerText={triggerText}
        submitButtonText="Yes, Not Invoicing"
        cancelButtonText="Cancel"
        handleSubmit={this.handleNotInvoicing}
        triggerType={triggerType}
        idKey="not-invoicing"
        modalSize="md"
      >
        <div className="style-guide">
          <h1 className="mb-3">
            Why
            {isConsultant ? 'are you' : `is ${consultantName}`}
            {' '}
            not invoicing for
            {monthYear}
            ?
          </h1>

          <textarea
            id="reason"
            className="form-control"
            value={reason}
            onChange={(e) => this.handleChange(e.target.value)}
            placeholder="No hours to submit..."
          />
        </div>
      </ModalTrigger>
    );
  }
}

NotInvoicingModal.propTypes = {
  consultantName: PropTypes.string.isRequired,
  monthYear: PropTypes.string,
  reason: PropTypes.string,
  invoiceId: PropTypes.string,
  projectId: PropTypes.string,
  consultantId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  notInvoicingUrl: PropTypes.string.isRequired,
  triggerType: PropTypes.string,
  triggerText: PropTypes.string,
  isConsultant: PropTypes.bool,
  redirectUrl: PropTypes.string,
};

NotInvoicingModal.defaultProps = {
  reason: null,
  invoiceId: null,
  monthYear: null,
  projectId: null,
  consultantId: null,
  triggerType: 'link',
  triggerText: 'Not Invoicing',
  isConsultant: false,
  redirectUrl: null,
};

export default NotInvoicingModal;
